import DashboardIcon from "../assets/images/icons/active/dashboard_white@3x.png";
import InactiveDashboardIcon from "../assets/images/icons/inactive/dashboard dissable@3x.png";
import BulkUpload from "../pages/EntityAdmin/BulkUpload/BulkUpload";
import CertificateActivityLogs from "../pages/EntityAdmin/Certificate/CertificateActivityLogs/CertificateActivityLogs";
import CertificateList from "../pages/EntityAdmin/Certificate/CertificateList/CertificateList";
import PreviewCertificate from "../pages/EntityAdmin/Certificate/PreviewCertificate/PreviewCertificate";
import ViewCertificate from "../pages/EntityAdmin/Certificate/ViewCertificate/ViewCertificate";
import Dashboard from "../pages/EntityAdmin/Dashboard/Dashboard";
import Profile from "../pages/EntityAdmin/Profile/Profile";
import UserActivityLogs from "../pages/EntityAdmin/Profile/UserActivityLogs/UserActivityLogs";

var EntityAdminRoutes = [
  {
    path: "dashboard",
    name: "Dashboard",
    element: <Dashboard/>,
    layout: "entity_admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "certificates",
    name: "Certificates",
    element: <CertificateList/>,
    layout: "entity_admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "bulk-upload",
    name: "Bulk Upload",
    element: <BulkUpload/>,
    layout: "entity_admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "view-certificate",
    name: "View Certificate",
    element: <ViewCertificate/>,
    layout: "entity_admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "certificates/preview-certificate/:certificate_id",
    name: "Preview Certificate",
    element: <PreviewCertificate/>,
    layout: "entity_admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "certificates/activity-logs/:certificate_id",
    name: "Certificate Activity Logs",
    element: <CertificateActivityLogs/>,
    layout: "entity_admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "my-profile",
    name: "Profile",
    element: <Profile/>,
    layout: "entity_admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },  
  {
    path: "my-activities",
    name: "Activity Logs",
    element: <UserActivityLogs/>,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
];
export default EntityAdminRoutes;
